import { render, staticRenderFns } from "./idCardVerify.vue?vue&type=template&id=5c858828&scoped=true"
import script from "./idCardVerify.vue?vue&type=script&lang=js"
export * from "./idCardVerify.vue?vue&type=script&lang=js"
import style0 from "./idCardVerify.vue?vue&type=style&index=0&id=5c858828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c858828",
  null
  
)

export default component.exports